import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./resources/js/event-bus.js